import { render } from "./Counterparties.vue?vue&type=template&id=6b132539"
import script from "./Counterparties.vue?vue&type=script&lang=js"
export * from "./Counterparties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__